import React from 'react';
import Slider from 'react-slick';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { ChevronLeft, ChevronRight, Calendar, ArrowRight } from 'lucide-react';
import { FaFacebook, FaTwitter, FaWhatsapp, FaLinkedin } from 'react-icons/fa';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const NoticiasCarousel = ({ noticias }) => {
    const navigate = useNavigate();

    // Custom arrow components
    const PrevArrow = (props) => {
        const { onClick } = props;
        return (
            <button
                onClick={onClick}
                className="absolute left-0 top-1/2 -translate-y-1/2 z-10 cursor-pointer bg-white/80 backdrop-blur-sm hover:bg-white shadow-md rounded-full p-2 transition-all duration-300 ml-2 hover:scale-110"
                aria-label="Anterior"
            >
                <ChevronLeft className="text-emerald-600 w-5 h-5" />
            </button>
        );
    };

    const NextArrow = (props) => {
        const { onClick } = props;
        return (
            <button
                onClick={onClick}
                className="absolute right-0 top-1/2 -translate-y-1/2 z-10 cursor-pointer bg-white/80 backdrop-blur-sm hover:bg-white shadow-md rounded-full p-2 transition-all duration-300 mr-2 hover:scale-110"
                aria-label="Próximo"
            >
                <ChevronRight className="text-emerald-600 w-5 h-5" />
            </button>
        );
    };

    // Configurações do slider
    const settings = {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    const irParaDetalhes = (id) => {
        navigate(`/noticias/${id}`);
    };

    return (
        <div className="w-full relative px-4">
            <style>{`
                .slick-dots li button:before {
                    color: #9ca3af;
                    font-size: 8px;
                    opacity: 0.5;
                }
                .slick-dots li.slick-active button:before {
                    color: #10b981;
                    opacity: 1;
                }
                .slick-dots {
                    bottom: -30px;
                }
                .slick-track {
                    display: flex;
                    gap: 16px;
                }
                .slick-slide > div {
                    height: 100%;
                }
            `}</style>
            
            <Slider {...settings} className="noticias-carousel">
                {noticias.map((noticia) => (
                    <div key={noticia.id} className="px-2 h-full">
                        <div
                            className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-lg overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1 h-full flex flex-col"
                            onClick={() => irParaDetalhes(noticia.id)}
                        >
                            {/* Imagem da Notícia */}
                            <div className="relative h-48 overflow-hidden">
                                <img
                                    src={noticia.imagem}
                                    alt={noticia.titulo}
                                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
                                <div className="absolute bottom-3 left-3 flex items-center gap-1.5 bg-black/40 backdrop-blur-sm rounded-full px-2.5 py-1">
                                    <Calendar className="w-3 h-3 text-white" />
                                    <span className="text-white text-xs">
                                        {format(new Date(noticia.data), "d MMM yyyy", { locale: ptBR })}
                                    </span>
                                </div>
                            </div>

                            {/* Conteúdo da Notícia */}
                            <div className="p-5 flex-1 flex flex-col">
                                <h3 className="text-lg font-medium text-gray-800 mb-2 line-clamp-2 hover:text-emerald-600 transition-colors">
                                    {noticia.titulo}
                                </h3>
                                <p className="text-gray-500 text-sm leading-relaxed line-clamp-3 mb-4 flex-1">
                                    {noticia.resumo}
                                </p>
                                <button
                                    className="inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-700 font-medium text-sm transition-colors group"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        irParaDetalhes(noticia.id);
                                    }}
                                >
                                    Ler mais
                                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default NoticiasCarousel;